import dayjs from 'dayjs'

export const convertUTCToLocal = (date = '') => {
    if (!date) return ''
    return dayjs.utc(date).local()
}

export const isValidArray = (data) => {
    return data && Array.isArray(data) && data.length > 0
}

export const isValidObject = (data) => {
    return (
        typeof data === 'object' &&
        data !== null &&
        Object.keys(data).length !== 0
    )
}
